/**
 * Import Lightgallery
 */

import lightGallery from 'lightgallery';

// DOM Content Loaded
document.addEventListener("DOMContentLoaded", function () {

    /**
     * Lightgallery
     */

    if (document.querySelector(".lightgallery")) {
        lightGallery(document.querySelector('.lightgallery'), {
            selector: '.lightgallery__item',
            speed: 400,
            download: false,
            counter: false,
            getCaptionFromTitleOrAlt: false,
        });
    }

});
